import useSWR from 'swr'
import { fetchTbsDef } from '@vt/apis/lib-ex/v2/tables'
import { mapValues, toString, find, omit } from 'lodash-es'

const dealTbDefsWithRef = (currentDefs, tbs) => {
  const originFields = (currentDefs && currentDefs.fields) || []
  const fields = originFields.map((field) => {
    if (
      ['ref', 'sysref'].includes(field.type) &&
      // TODO: 想办法让 app 也能处理
      !['app'].includes(field.refType)
    ) {
      const tbId = field.dataFromTbId || field.tbId
      // TODO: 这里应该弹出 toast
      if (!tbId) {
        console.error('[app-provider] 字段定义错误, 找不到 tbId', field)
        return field
      }
      const refTbdefs = tbs[toString(tbId)] || tbs[tbId]

      if (!refTbdefs) {
        console.error('[app-provider] 字段定义错误, 找不到表单定义', field)
        return field
      }
      // console.log(`[app-provider] tbs2:`, { ...field, refTbdefs })

      return { ...field, refTbdefs }
    }

    return field
  })
  // console.log(`[app-provider] tbs:`, fields)

  const lookupedFields = fields.map((field) => {
    if (field.type === 'lookup') {
      const refFieldSpec = fields.find((v) => v.slug === field.refSlug)
      if (refFieldSpec) {
        const { refTbdefs } = refFieldSpec
        const refFeilds = (refTbdefs && refTbdefs.fields) || []
        const refField = find(refFeilds, (v) => v.slug === field.lookupSlug)
        // field.refField = refField

        if (refField) {
          return {
            type: 'lookup',
            ...refField,
            refField,
            lookup: field,
            slug: field.slug,
            title: field.title,
            hiddenWhenCreate: field.hiddenWhenCreate,
          }
        }
      }
    }
    // 自引用类型
    if (field.selfRefSlug) {
      const refFieldSpec = fields.find((v) => v.slug === field.selfRefSlug)
      if (refFieldSpec) {
        // 这里服务端经常返回错误，前端处理下
        const omitedViewDef = omit(field.ownViewDef, ['isBindStandard'])
        return {
          ...refFieldSpec,
          ...omitedViewDef,
          refField: refFieldSpec,
          ownViewDef: field.ownViewDef,
          slug: field.slug,
          title: field.title,
          selfRefSlug: field.selfRefSlug,
          isBindStandard: field.isBindStandard,
          hiddenWhenCreate: field.hiddenWhenCreate,
        }
      }
    }

    return field
  })
  // console.log(`[app-provider] tbs:`, lookupedFields)

  return { ...currentDefs, fields: lookupedFields }
}

export const useTbConfigsSWR = (appId) => {
  const { data, mutate, error } = useSWR([`apps-tbs`, appId], {
    fetcher: () =>
      fetchTbsDef(appId).then((tbs) => {
        const dealedTbs = {}
        mapValues(tbs, (tb) => {
          const tbDefs = dealTbDefsWithRef(tb, tbs)
          dealedTbs[tb.tbId] = tbDefs
          dealedTbs[tb.tbNameId] = tbDefs
        })
        return { dealedTbs, tbs }
      }),
    // fetcher: (args) => {
    //   if (args && args[1] === 'reload') {
    //     return fetchTbsDef(appId).then(store.save)
    //   }
    //   const cacheExpired =
    //     new Date().getTime() - (store.loadedAt || 0) > 6 * 60 * 1000
    //   console.log('[app-tbs-cache] expired?', store.loadedAt, cacheExpired)
    //   if (cacheExpired) {
    //     return fetchTbsDef(appId).then(store.save)
    //   }
    //   return store.load().then((fdb) => {
    //     if (fdb.length === 0) {
    //       return fetchTbsDef(appId).then(store.save)
    //     }
    //     return fdb
    //   })
    // },
    dedupingInterval: 3 * 1000 * 60,
  })

  return {
    tbs: data && data.dealedTbs,
    tbsRaw: data && data.tbs,
    mutate,
    error,
    isTbsLoading: !error && !data,
  }
}
